/* ====== UPSELL POPUP – Puure 360° Faucet Aerator ====== */
(function(){
  var UPSELL = window.PuureOcuConfig;


  var overlay = document.getElementById('ocu-popup-overlay');
  var closeBtn = document.getElementById('ocu-close-btn');
  var addBtn = document.getElementById('ocu-add-btn');
  var skipBtn = document.getElementById('ocu-skip-btn');
  var isProcessing = false;
  var currentImageIndex = 0;

  function fetchProductData(cb){
    /* Skip fetch when Liquid already gave us everything (priceFormatted +
       variantId + serverImages). Avoids the GBP-cents value from /products.js
       overwriting the market-correct Liquid value. */
    if (UPSELL.priceFormatted && UPSELL.variantId && UPSELL.serverImages && UPSELL.serverImages.length) {
      UPSELL.images = UPSELL.serverImages.slice();
      cb(true);
      return;
    }
    fetch('/products/' + UPSELL.productHandle + '.js')
      .then(function(r){ if(!r.ok) throw new Error('Not found'); return r.json(); })
      .then(function(product){
        if (!UPSELL.title) UPSELL.title = product.title;
        if (!UPSELL.images.length) UPSELL.images = product.images || [];
        var variant = product.variants[0];
        if(variant){
          if (!UPSELL.variantId) UPSELL.variantId = variant.id;
          UPSELL.price = variant.price || 0;
          UPSELL.compareAtPrice = variant.compare_at_price || 0;
        }
        if(!UPSELL.images.length && product.featured_image) UPSELL.images = [product.featured_image];
        cb(true);
      })
      .catch(function(){ cb(false); });
  }

  function formatPrice(cents){
    if (window.PuureMoney) return window.PuureMoney.format(cents);
    var S = window.__PUURE__ || {};
    var sym = S.currencySymbol || S.currencySymbolFromLocale || '\u00a3';
    return sym + (cents / 100).toFixed(2);
  }

  function updateMainImage(index){
    currentImageIndex = index;
    var mainImg = document.getElementById('ocu-main-img');
    if(mainImg && UPSELL.images[index]){
      mainImg.src = UPSELL.images[index];
      mainImg.alt = UPSELL.title + ' - Image ' + (index+1);
    }
    var thumbs = document.querySelectorAll('.ocu-thumb');
    for(var i=0;i<thumbs.length;i++) thumbs[i].classList.toggle('active', i===index);
  }

  function initGallery(){
    var track = document.querySelector('.ocu-thumb-track');
    if(!track) return;
    track.innerHTML = '';
    var defaultIdx = UPSELL.images.length > 1 ? 1 : 0;
    UPSELL.images.forEach(function(img, idx){
      var btn = document.createElement('button');
      btn.className = 'ocu-thumb' + (idx===defaultIdx ? ' active' : '');
      btn.innerHTML = '<img src="'+img+'" alt="Thumbnail '+(idx+1)+'">';
      btn.addEventListener('click', function(){ updateMainImage(idx); });
      track.appendChild(btn);
    });
    var prevBtn = document.querySelector('.ocu-thumb-prev');
    var nextBtn = document.querySelector('.ocu-thumb-next');
    if(UPSELL.images.length <= 1){
      if(prevBtn) prevBtn.style.display='none';
      if(nextBtn) nextBtn.style.display='none';
    } else {
      if(prevBtn){ prevBtn.style.display='flex'; prevBtn.onclick=function(){ updateMainImage(currentImageIndex>0?currentImageIndex-1:UPSELL.images.length-1); }; }
      if(nextBtn){ nextBtn.style.display='flex'; nextBtn.onclick=function(){ updateMainImage(currentImageIndex<UPSELL.images.length-1?currentImageIndex+1:0); }; }
    }
    updateMainImage(defaultIdx);
  }

  function populatePopup(){
    fetchProductData(function(){
      var el;
      el = document.getElementById('ocu-product-title'); if(el) el.textContent = UPSELL.title;
      el = document.getElementById('ocu-header-subtitle'); if(el) el.textContent = UPSELL.headerSubtitle;
      el = document.getElementById('ocu-product-desc'); if(el) el.innerHTML = UPSELL.description;
      el = document.getElementById('ocu-product-price');
      if(el){
        /* Prefer the Liquid-rendered, market-localized price string. */
        el.textContent = UPSELL.priceFormatted || formatPrice(UPSELL.price);
      }
      el = document.getElementById('ocu-product-price-compare');
      if(el){
        if(UPSELL.compareAtPriceFormatted){
          el.textContent = UPSELL.compareAtPriceFormatted; el.style.display='inline-block';
        } else if(UPSELL.compareAtPrice && UPSELL.compareAtPrice > UPSELL.price){
          el.textContent = formatPrice(UPSELL.compareAtPrice); el.style.display='inline-block';
        } else { el.textContent=''; el.style.display='none'; }
      }
      initGallery();
    });
  }

  function showPopup(){
    if(!overlay) return;
    populatePopup();
    overlay.style.display = 'flex';
    requestAnimationFrame(function(){ requestAnimationFrame(function(){ overlay.classList.add('is-visible'); }); });
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
  }

  function hidePopup(){
    if(!overlay) return;
    overlay.classList.remove('is-visible');
    setTimeout(function(){
      overlay.style.display = 'none';
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    }, 300);
  }

  function refreshAndOpenDrawer(){
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      document.querySelectorAll('.cart-count, [data-cart-count], .cart-count-bubble span').forEach(function(el){ el.textContent = cart.item_count; });
    });
    setTimeout(function(){
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.show === 'function') /* ouvre le tiroir dès qu'il existe : cartType peut valoir 'popover' (le flux natif n'est pas déclenché par ce widget) */{
        cartDrawer.show();
      }
    }, 150);
  }

  function addUpsellToCart(){
    if(isProcessing) return;
    isProcessing = true;
    addBtn.disabled = true;
    addBtn.textContent = UPSELL.i18nAdding;
    fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ items:[{id:Number(UPSELL.variantId), quantity:1}] })
    })
    .then(function(r){ if(!r.ok) throw new Error('Failed'); return r.json(); })
    .then(function(){
      hidePopup();
      setTimeout(refreshAndOpenDrawer, 250);
    })
    .catch(function(){
      alert(UPSELL.i18nError);
      hidePopup();
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    })
    .finally(function(){
      isProcessing = false;
      addBtn.disabled = false;
      addBtn.textContent = UPSELL.i18nAdd;
    });
  }

  function declineUpsell(){
    hidePopup();
    setTimeout(refreshAndOpenDrawer, 250);
  }

  if(closeBtn) closeBtn.addEventListener('click', declineUpsell);
  if(skipBtn) skipBtn.addEventListener('click', declineUpsell);
  if(addBtn) addBtn.addEventListener('click', addUpsellToCart);
  if(overlay) overlay.addEventListener('click', function(e){ if(e.target===overlay) declineUpsell(); });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape' && overlay && overlay.classList.contains('is-visible')) declineUpsell(); });

  window.showOCUPopup = showPopup;
})();
